import React from 'react';

const FairHousing = () => {
  return (
          <div className="min-h-screen w-full  text-left">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
        <div className="bg-white p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Fair Housing Policy</h1>
          
          <p className="text-sm text-gray-600 mb-8">LAST UPDATED: December 1, 2025</p>
          
          <div className="prose prose-lg max-w-none">
            <p className="mb-6">
              The Romanelli Group LLC ("The Romanelli Group," "we," "our," or "us") is firmly committed to providing equal professional service in real estate. We support and uphold the principles of the Federal Fair Housing Act (Title VIII of the Civil Rights Act of 1968, as amended), which makes it illegal to advertise or make any statement that indicates a:
            </p>
            
            <blockquote className=" pl-4 italic mb-6 p-4">
              "preference, limitation, or discrimination because of race, color, religion, sex, handicap, familial status, or national origin, or an intention to make any such preference, limitation, or discrimination."
            </blockquote>
            
            <p className="mb-6">
              All real estate information, advertising, marketing materials, and client services provided through our website or platforms are subject to this law.
            </p>
            
            <p className="mb-8">
              Your state or local jurisdiction may impose additional Fair Housing requirements. As a real estate team serving Central Ohio, we are committed to abiding by all federal, state, and local Fair Housing regulations, including those applicable within Columbus, Ohio, and surrounding areas.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Commitment to Equal Housing Opportunity</h2>
            
            <p className="mb-4">The Romanelli Group believes in the letter and spirit of Fair Housing. This includes:</p>
            
            <ul className="list-disc pl-6 mb-8 space-y-2">
              <li>Providing equal access to housing opportunities for all individuals</li>
              <li>Ensuring our marketing and advertising reflect inclusive, non-discriminatory practices</li>
              <li>Offering professional services without bias or limitation</li>
              <li>Maintaining compliance with all applicable housing laws and standards</li>
            </ul>
            
            <p className="mb-8">
              We strive to foster a community and client experience where everyone is treated fairly, respectfully, and without discrimination.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Brokerage Information</h2>
            
            <div className="">
              <p className="">
                The Romanelli Group LLC is an independently operated real estate team under KW Greater Columbus.
              </p>
              <p className="">
                Keller Williams is an Equal Opportunity Employer and supports full compliance with the Fair Housing Act.
              </p>
              <p>
                Each Keller Williams® office is independently owned and operated.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FairHousing;